import React from 'react';

const AnimatedBorderSVG = () => (
    <filter id="animated-border-filter" x="-20%" y="-20%" width="140%" height="140%">
        <feTurbulence x="0" y="0" baseFrequency="0.009" numOctaves="5" seed="2">
            <animate attributeName="baseFrequency" dur="60s" values="0.015;0.008;0.015" repeatCount="indefinite" />
        </feTurbulence>
        <feDisplacementMap in="SourceGraphic" scale="30" xChannelSelector="R" yChannelSelector="G" />
    </filter>
);

export default AnimatedBorderSVG;